import { Col, Divider, Row, Space } from "antd";
import React, { useMemo } from "react";
import { CustomTag } from "../../../../Tags";
import { getKeyEnum, getValueEnum } from "../../../Unbookable/utils";
import { CustomCard } from "../../Detail/Card.styled";
import {
  ProductCategoryStatus,
  ProductCategoryStatusTag,
  ProductCategoryStatusType,
} from "../../Tags/ProductCategoryStatus";
import { ReturnStatus } from "../../Tags/ReturnStatus";
import { ProductOptionsInfoCardForm } from "../Product/ProductOption/Item";
import { ProductThumbnail } from "./Thumbnail";

interface RepairOrderItemBoxFormProps {
  groupItem: any;
  isDomestic?: boolean;
}

/**
 * 상품카테고리별 카드폼
 * @param param0
 * @returns
 */
export const RepairOrderItemBoxForm: React.FC<RepairOrderItemBoxFormProps> = ({
  groupItem,
  isDomestic,
}) => {
  const [type, orderItems] = groupItem;

  /**
   * 썸네일
   */
  const imgUrl = useMemo(() => {
    if (type === "WHEEL_ALIGNMENT") {
      return "/wheel-alignment.png";
    }

    if (type === "TIRE_STORAGE") {
      return "/tire-storage.png";
    }

    return orderItems?.[0].media?.bufferFullUrl;
  }, [orderItems]);

  /**
   * @notice 엔진오일, 브레이크패드, 와이퍼는 패키지로
   * @hisyory  (240102) 와이퍼는 배송만있어서 현재 해당사항 없음
   * @notice 휠 + 타이어는 한그룹으로, 각 태그표출, 패키지 상품은 대표 태그만
   * @history (240529) 휠얼 분리
   */
  return (
    <CustomCard
      style={{ borderRadius: 6 }}
      bodyStyle={{ padding: 16, width: "100%" }}
    >
      <Row
        align="stretch"
        gutter={[16, 12]}
        wrap={false}
        style={{ width: "100%" }}
      >
        <Col flex="none">{imgUrl && <ProductThumbnail src={imgUrl} />}</Col>
        <Col flex="auto">
          <Row gutter={[16, 12]}>
            {["WHEEL_ALIGNMENT", "TIRE", "TIRE_STORAGE"].includes(type) &&
              orderItems?.map((item: any, idx: number, arr: Array<any>) => (
                <React.Fragment
                  key={`${item.orderItemNo}:${item.erpCode}:${idx}`}
                >
                  {type && (
                    <Col span={24}>
                      <Space size={2}>
                        <ProductCategoryStatusTag
                          value={
                            getKeyEnum(
                              item.productCategoryName as string,
                              ProductCategoryStatus
                            ) as ProductCategoryStatusType
                          }
                        />
                        {item.orderItemReturnStatus && (
                          <CustomTag colors="red">
                            {getValueEnum(
                              item.orderItemReturnStatus,
                              ReturnStatus
                            )}
                          </CustomTag>
                        )}
                      </Space>
                    </Col>
                  )}
                  <Col span={24}>
                    <ProductOptionsInfoCardForm
                      title={
                        item.productCategoryName === "보관서비스"
                          ? "보관서비스"
                          : item.productCategoryName === "휠얼라인먼트"
                          ? `휠얼라인먼트 / ${isDomestic ? "국산차" : "수입차"}`
                          : `${item?.productBrandName || item?.brand} ${
                              item.orderItemName
                            }`
                      }
                      erpCode={item.erpCode}
                      amount={item.orderItemAmount}
                    />
                  </Col>
                  {idx !== arr.length - 1 && (
                    <Divider dashed style={{ margin: 0 }} />
                  )}
                </React.Fragment>
              ))}
            {type !== "TIRE" &&
              orderItems?.[0].orderItemProductOptions?.map(
                (item: any, idx: number, arr: Array<any>) => {
                  return (
                    <React.Fragment
                      key={`${orderItems?.[0].orderItemNo}:${orderItems?.[0].erpCode}:${idx}`}
                    >
                      {type && idx === 0 && (
                        <Col span={24}>
                          <Space size={2}>
                            <ProductCategoryStatusTag value={type} />
                            {orderItems?.[0].orderItemReturnStatus && (
                              <CustomTag colors="red">
                                {getValueEnum(
                                  orderItems?.[0].orderItemReturnStatus,
                                  ReturnStatus
                                )}
                              </CustomTag>
                            )}
                          </Space>
                        </Col>
                      )}
                      <Col span={24}>
                        <ProductOptionsInfoCardForm
                          title={
                            item.productOptionName || item.productOptionValue
                          }
                          description={
                            type === "ENGINE_OIL"
                              ? orderItems?.[0].orderItemProductDetail
                              : undefined
                          }
                          erpCode={item.erpCode}
                          amount={item.amount}
                        />
                      </Col>
                      {idx !== arr.length - 1 && (
                        <Divider dashed style={{ margin: 0 }} />
                      )}
                    </React.Fragment>
                  );
                }
              )}
          </Row>
        </Col>
      </Row>
    </CustomCard>
  );
};
